// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBf8LGSvHtjpH5Tao4uFvNqwjRMKK8BcnI",
  authDomain: "cook-445aa.firebaseapp.com",
  projectId: "cook-445aa",
  storageBucket: "cook-445aa.appspot.com",
  messagingSenderId: "766341323055",
  appId: "1:766341323055:web:897eb50d007c0bf38529da",
  measurementId: "G-WCY7SXQRFV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const rdb = getDatabase(app);

export { auth, db, storage, rdb};
